import { FooterColumn } from "@src/components/Footer/FooterColumn";

export const Footer = () => {
  const footerItems = [
    {
      footerTitle: "Home",
      footerLinks: [
        { linkText: "About", linkAnchor: "/about" },
        { linkText: "Blog", linkAnchor: "/blog" },
        { linkText: "FAQ", linkAnchor: "/faq" },
      ],
    },
    {
      footerTitle: "Contact",
      footerLinks: [
        {
          linkText: "Contact",
          linkAnchor: "/contact",
        },
        {
          linkText: "Twitter",
          linkAnchor: "#",
          externalLink: true,
        },
        {
          linkText: "Instagram",
          linkAnchor: "#",
          externalLink: true,
        },
      ],
    },
    {
      footerTitle: "Legal",
      footerLinks: [
        {
          linkText: "Terms & Conditions",
          linkAnchor: "/legal/terms_of_service",
        },
        {
          linkText: "Privacy Policy",
          linkAnchor: "/legal/privacy_policy",
        },
        { linkText: "Data Policy", linkAnchor: "/legal/data_policy" },
      ],
    },
  ];
  return (
    <footer className="_background-color--var_gray-10_ _border-top--1px_solid_var_gray-20_">
      <div className="_width--95percent _margin--0_auto _padding-top--6rem _padding-bottom--6rem">
        <div className="_position--relative">
          {footerItems.map((item, index) => (
            <FooterColumn key={index} footerItem={item}></FooterColumn>
          ))}
          <div className="_display--inline-block footerImageBookend">
            <a
              href="https://www.maxnelsonwebsite.com"
              target="_blank"
              rel="noreferrer"
            >
              <img src="/images/icons/nyan-cat.png" alt="Timeline" />
            </a>
          </div>
        </div>
        <div className="_margin-top--8rem _font-size--14px _text-align--center">
          <p className="_color--var_text-primary_">
            Timeline © {new Date().getFullYear()}
          </p>
        </div>
      </div>
    </footer>
  );
};
